import moment from "moment";

function ExportCompanyDashboardFileFormatter(companyName, segmentName) {
  return `${companyName}-${segmentName}-${moment(new Date()).format(
    "YYYY_MM_DD"
  )}`;
}

export default ExportCompanyDashboardFileFormatter;
